import { Alert, AlertTitle } from '@mui/material';
import { useNotification } from '../hooks/useNotification';
import { FC, useMemo } from 'react';
import { useExpireLocalStorage } from '../hooks/useExpireLocalStorage';
import { simpleHash } from '../utils';

const SiteStatus: FC = () => {
    const { data: notification } = useNotification();
    const [closed, setClosed] = useExpireLocalStorage<Record<number, boolean>>('notification-closed', {});
    const notificationHash = useMemo(
        () => (notification ? simpleHash(JSON.stringify(notification)) : 0),
        [notification]
    );

    const handleClose = () => {
        setClosed((map) => {
            return { ...map, [notificationHash]: true };
        });
    };

    return notification && !closed[notificationHash] ? (
        <Alert
            severity={notification.severity || 'warning'}
            variant="filled"
            style={{ alignItems: 'center', borderRadius: 0 }}
            onClose={notification.closeable ? handleClose : undefined}
        >
            {notification.title && <AlertTitle sx={{ marginBottom: 0 }}>{notification.title}</AlertTitle>}
            {notification.message}
        </Alert>
    ) : null;
};

export default SiteStatus;
